import * as actionType from "./actionTypes";
import axios from "../../shared/axios";

const fetchAboutMeStart = () => ({
  type: actionType.FETCH_ABOUTME_START,
});

const fetchAboutMeSuccess = (aboutMe) => ({
  type: actionType.FETCH_ABOUTME_SUCCESS,
  key: aboutMe.key,
  fullName: aboutMe.fullName,
  profesion: aboutMe.profesion,
  profileImage: aboutMe.profileImage,
  profileImageSmall: aboutMe.profileImageSmall,
  socialMedia: aboutMe.socialMedia,
  summary: aboutMe.summary,
});

const fetchAboutMeFail = (error) => ({
  type: actionType.FETCH_ABOUTME_FAIL,
  error,
});

export const fetchAboutMe = () => async (dispatch) => {
  dispatch(fetchAboutMeStart());

  const queryParams = `?orderBy="fullName"&equalTo="Daniel Pérez Parada"`;
  try {
    const res = await axios.get(`aboutMe.json${queryParams}`);
    const [key, value] = Object.entries(res.data)[0];
    value.profileImage = require(`../../assets/images/${value.profileImage}`).default;
    value.profileImageSmall = require(`../../assets/images/${value.profileImageSmall}`).default;
    const aboutMe = { key, ...value };
    dispatch(fetchAboutMeSuccess(aboutMe));
  } catch (error) {
    dispatch(fetchAboutMeFail(error.message));
  }
};
